import { useCallback, useState } from 'react';

const MAX_HISTORY = 40;

/**
 * Histórico undo/redo para o deck de slides do ARCA.
 * @param {object[]} initial
 */
export default function useArcaHistory(initial = []) {
  const [present, setPresent] = useState(initial);
  const [past, setPast] = useState([]);
  const [future, setFuture] = useState([]);

  const setSlides = useCallback((next, { record = true } = {}) => {
    setPresent((prev) => {
      const resolved = typeof next === 'function' ? next(prev) : next;
      if (record) {
        setPast((p) => [...p, prev].slice(-MAX_HISTORY));
        setFuture([]);
      }
      return resolved;
    });
  }, []);

  const undo = useCallback(() => {
    setPast((p) => {
      if (!p.length) return p;
      const previous = p[p.length - 1];
      setPresent((curr) => {
        setFuture((f) => [curr, ...f].slice(0, MAX_HISTORY));
        return previous;
      });
      return p.slice(0, -1);
    });
  }, []);

  const redo = useCallback(() => {
    setFuture((f) => {
      if (!f.length) return f;
      const [next, ...rest] = f;
      setPresent((curr) => {
        setPast((p) => [...p, curr].slice(-MAX_HISTORY));
        return next;
      });
      return rest;
    });
  }, []);

  const loadSlides = useCallback((slides) => {
    setPast([]);
    setFuture([]);
    setPresent(Array.isArray(slides) ? slides : []);
  }, []);

  return {
    slides: present,
    setSlides,
    loadSlides,
    undo,
    redo,
    canUndo: past.length > 0,
    canRedo: future.length > 0,
  };
}
